import { useContext, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { MobXProviderContext } from "mobx-react";

function BulkUserRemove({
  visible,
  setModal,
  bulkUsers,
  mealPlanId,
  meal,
  fromMeal = false,
  onComplete,
  handleApplyPressed,
}) {
  const { mealManagementStore } = useContext(MobXProviderContext);
  const { userStore } = useContext(MobXProviderContext);
  const { homeStore } = useContext(MobXProviderContext);
  const { locationID } = userStore;
  const mealPlan = mealManagementStore.mealPlan;

  const onDeletePress = () => {
    if (fromMeal) {
      homeStore
        ?.deleteEmployeeMeal({
          location_id: locationID,
          meal_id: meal?.id,
          ids: bulkUsers?.map((user) => user?.employee_id),
        })
        .then(() => {
          onComplete();
          handleApplyPressed();
          setModal(false);
        });
    } else
      mealManagementStore
        .deleteEmployeeMealPlan(
          {
            location_id: locationID,
            ids: bulkUsers?.map((user) => user?.id),
          },
          mealPlan?.id
        )
        .then(() => setModal(false));
  };

  return (
    <Transition
      appear
      show={visible ? true : false}
      as={Fragment}
      avoidClose={true}
    >
      <Dialog as="div" className="relative z-[90]" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center sm:p-4 md:p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[696px] h-[276px] d-col justify-between rounded-xl md:w-6/12 transform overflow-hidden sm:rounded-2xl md:rounded-2xl bg-white px-8 pb-8 pt-[24px] text-left align-middle shadow-xl transition-all">
                <div className="d-row justify-between items-center">
                  <div />
                  <button
                    onClick={() => setModal(false)}
                    className="text-dark-gray hover:text-yellow-600"
                    aria-label="Close"
                  >
                    <span className="text-xl">&times;</span>
                  </button>
                </div>

                <h1 className="self-center font-inter-semibold text-[24px] text-dark-gray">
                  Remove users?
                </h1>
                <span className="font-inter-regular text-[16px] text-dark-gray self-center">
                  Are you sure you want to delete these users?
                </span>

                <div className="d-row w-full items-center mt-[24px] justify-center">
                  <button
                    className="btn-light btn-style py-3 px-5"
                    onClick={() => setModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-purple btn-style py-3 px-6 ml-3"
                    onClick={onDeletePress}
                  >
                    Delete
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default BulkUserRemove;
